import React from "react";
import { useKT } from "../i18n/kt";
import { fmtDay } from "../rates/rateModel";
import { CHANGE_LABEL, ChangeRow, changeValues } from "./sareeEditModel";

/** Corrections made after work was entered, oldest first: what changed, old → new, who and when. */
const ChangeList = ({ changes }: { changes: ChangeRow[] }) => {
  const { t } = useKT();
  if (!changes.length) return null;
  return (
    <ul className="kh-changes">
      {changes.map((c, i) => {
        const v = changeValues(c, fmtDay);
        return (
          <li key={i}>
            <strong>{t(CHANGE_LABEL[c.field] || c.field)}</strong>: {v.from} → {v.to}
            <small>
              {c.byName || t("Someone")}
              {c.at ? ` · ${new Date(c.at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}` : ""}
              {c.source === "MCP" ? ` · ${t("by the AI assistant")}` : ""}
              {c.reason ? ` · “${c.reason}”` : ""}
            </small>
          </li>
        );
      })}
    </ul>
  );
};

export default ChangeList;
